import type { ImageLoadData } from '@/map-phaser-new/interfaces'

type EventsShipImageLoadDataFunction = (eventAssetsDirectory: string) => ImageLoadData[]

export const eventsShipImageLoadData: EventsShipImageLoadDataFunction = (
  eventAssetsDirectory: string,
): ImageLoadData[] => [
  {
    name: 'buildings.event_ship',
    compressed: false,
    data: {
      astc: {
        type: 'KTX',
        textureURL: `events/${eventAssetsDirectory}/event-ship/event-ship-astc12x12_v2.ktx`,
      },
      etc: {
        type: 'KTX',
        textureURL: `events/${eventAssetsDirectory}/event-ship/event-ship-etc2rgba_v2.ktx`,
      },
      img: {
        textureURL: `events/${eventAssetsDirectory}/event-ship/event-ship-png8_v3.avif`,
      },
      place: `events/${eventAssetsDirectory}/event-ship/event-ship-png8_v3.avif`,
    },
  },
  {
    name: 'buildings.event_ship_outline',
    compressed: false,
    data: {
      astc: {
        type: 'KTX',
        textureURL: `events/${eventAssetsDirectory}/event-ship-outline/event-ship-outline-astc12x12_v2.ktx`,
      },
      etc: {
        type: 'KTX',
        textureURL: `events/${eventAssetsDirectory}/event-ship-outline/event-ship-outline-etc2rgba_v2.ktx`,
      },
      img: {
        textureURL: `events/${eventAssetsDirectory}/event-ship-outline/event-ship-outline-png8_v3.avif`,
      },
      place: `events/${eventAssetsDirectory}/event-ship-outline/event-ship-outline-png8_v3.avif`,
    },
  },
]
